import { bootstrap } from './compatibility-guide';

(() => {
  const manufacturersFields: NodeListOf<HTMLElement> = document.querySelectorAll('.cg-manufacturers');
  if (manufacturersFields.length === 0) {
    return;
  }

  // Bootstrap compatibility guide dropdowns.
  bootstrap(manufacturersFields);
})();
